import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Public
export const fetchPanchangam = async (date, calendarType = "amanta", coords = null) => {
  const params = { date, calendar_type: calendarType };
  if (coords) {
    params.latitude = coords.latitude;
    params.longitude = coords.longitude;
    params.tz_offset_min = coords.tzOffsetMin;
  }
  const { data } = await axios.get(`${API}/panchangam`, { params });
  return data;
};

export const fetchTranslations = async () => {
  const { data } = await axios.get(`${API}/translations`);
  return data;
};

export const checkMuhurtam = async (payload) => {
  const { data } = await axios.post(`${API}/muhurtam/check`, payload);
  return data;
};

// Admin
const authHeader = () => {
  const t = localStorage.getItem("yagnika_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/auth/login`, { email, password });
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/admin/auth/me`, { headers: authHeader() });
  return data;
};

export const adminListTranslations = async () => {
  const { data } = await axios.get(`${API}/admin/translations`, { headers: authHeader() });
  return data;
};

export const adminUpsertTranslation = async (payload) => {
  const { data } = await axios.post(`${API}/admin/translations`, payload, { headers: authHeader() });
  return data;
};

export const adminDeleteTranslation = async (key) => {
  const { data } = await axios.delete(`${API}/admin/translations/${encodeURIComponent(key)}`, {
    headers: authHeader(),
  });
  return data;
};
